/**
 * Executes a function when it stops being invoked for n seconds
 */
export function debounce<T extends (...args: Parameters<T>) => void>(
	callback: T,
	delay: number,
	immediate?: boolean
): (...args: Parameters<T>) => void {
	let timeout: ReturnType<typeof setTimeout> | null

	return function (this: unknown, ...args: Parameters<T>) {
		const later = () => {
			timeout = null
			if (!immediate) {
				callback.apply(this, args)
			}
		}
		const callNow = immediate && !timeout

		if (timeout) {
			clearTimeout(timeout)
		}
		timeout = setTimeout(later, delay)

		if (callNow) {
			callback.apply(this, args)
		}
	}
}
